export const CHANGE_LANGUAGE_TO_THAI = 'CHANGE_LANGUAGE_TO_THAI'
export const CHANGE_LANGUAGE_TO_ENG = 'CHANGE_LANGUAGE_TO_ENG'

export type Action = {
    type: typeof CHANGE_LANGUAGE_TO_THAI | typeof CHANGE_LANGUAGE_TO_ENG
}

export const thaiPlease = (): Action => ({
    type: CHANGE_LANGUAGE_TO_THAI,
})

export const englishPlease = (): Action => ({
    type: CHANGE_LANGUAGE_TO_ENG,
})
